// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".k-footer a[data-v-20f3b012]{color:#fff;text-decoration:none}.k-footer__main a[data-v-20f3b012]{display:block;font-size:16px;line-height:22px;margin-bottom:16px}.k-footer .disabled[data-v-20f3b012]{cursor:not-allowed;opacity:.25;pointer-events:none}", ""]);
// Exports
module.exports = exports;
